import OnDemandDevelopers from "../on-demand-developers";
import ProjectByEquity from "../project-by-equity";
import FullProjectDevelopment from "../full-project-development";
import WhatServices from "../what-services";
import Confirmation from "../confirmation";
import NavBar from "../nav-bar";
// import Intro from "../Intro";
// import OurServices from "../our-services";
// import SeeOurWork from "../see-our-work";
// import ImpactAcrossIndustries from "../impact-across-industries";
// import WhatMakeUsDifferent from "../what-make-us-different";
// import WhatOurClientSays from "../what-our-client-says";
// import MeetOurTeam from "../meet-our-team";
// import AboutUs from "../about-us";
import Grid from "@mui/material/Grid/Grid";
import {CustomLabelMediumBold, CustomLabelMediumRegular, CustomLabelXSmallRegular} from "../common/CustomLabel";
import Box from "@mui/material/Box/Box";
import IPHONE151 from "../../assets/images/iPhone 15 Pro-1.png";
import ContactUs from "../contact-us";
import Footer from "../footer";
import React, {useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import createTheme from "@mui/material/styles/createTheme";
// import IntroDetails from "../intro-details";
// import WorkDetails from "../work-details";
// import PROJECT1 from "../../assets/images/project_1.png";
// import PROJECT2 from "../../assets/images/project2.png";
// import PROJECT3 from "../../assets/images/project3.png";
// import WorkCard from "../card-work";
import Certificate1 from "../../assets/images/certificate.png";
import Paper from "@mui/material/Paper/Paper";
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import StaticMapIcon from "../../assets/images/static-map.png";
import { Helmet } from 'react-helmet';

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


const ContactUsDetails = ({}) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [showFullProject, setShowFullProject] = useState(false);
    const [showOnDemandDevelopers, setShowOnDemandDevelopers] = useState(false);
    const [showProjectByEquity, setShowProjectByEquity] = useState(false);
    const [showWhatServices, setShowWhatService] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);


    const serviceRef = useRef(null);
    const portfolioRef = useRef(null);
    const testimonalsRef = useRef(null);
    const partnersRef = useRef(null);
    const contactUsRef = useRef(null);


    const CertificatesList = [
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
        {
            issued_by: "Issued By: Google",
            img: Certificate1,
            title: "ISO 9001: Quality Management",
            description: "Ensuring top-tier quality and customer satisfaction in all our processes."
        },
    ]


    return (
        <Grid style={{width: "100vw", height: "100vh", overflowX: "hidden",}}>
             <Helmet prioritizeSeoTags>
                        <title>Contact Us - Custom Mobile app development Company - OSTRYX</title>
                        <link rel="canonical" href="https://ostryx.com/contact-us" />
                        <meta name="url" content="https://ostryx.com/contact-us" />
                        <meta name="title" content="Contact Us - Custom Mobile app development Company - OSTRYX" />
                        <meta name="description" content="Get in touch with OSTRYX, a leading custom mobile app development company. Let's build innovative, scalable, and user-friendly mobile solutions together!" />
                        <meta name="keywords" content="OSTRYX, contact OSTRYX, mobile app development, custom app solutions, app development company, business apps, software development, mobile solutions" />
                        <meta property="og:title" content="Contact Us - Custom Mobile app development Company - OSTRYX" />
                        <meta property="og:description" content="Get in touch with OSTRYX, a leading custom mobile app development company. Let's build innovative, scalable, and user-friendly mobile solutions together!" />
            </Helmet>

            {
                showOnDemandDevelopers && <OnDemandDevelopers setShowOnDemandDevelopers={setShowOnDemandDevelopers}
                                                              setShowConfirmation={setShowConfirmation}
                />
            }

            {
                showProjectByEquity && <ProjectByEquity setShowProjectByEquity={setShowProjectByEquity}
                                                        setShowConfirmation={setShowConfirmation}/>
            }


            {
                showFullProject && <FullProjectDevelopment setShowFullProject={setShowFullProject}
                                                           setShowConfirmation={setShowConfirmation}/>
            }


            {
                showWhatServices &&
                <WhatServices setShowWhatService={setShowWhatService} setShowFullProject={setShowFullProject}
                              setShowProjectByEquity={setShowProjectByEquity}
                              setShowOnDemandDevelopers={setShowOnDemandDevelopers}/>
            }


            {
                showConfirmation && <Confirmation setShowConfirmation={setShowConfirmation}/>
            }

            <NavBar isMenuClicked={isMenuClicked} serviceRef={serviceRef} portfolioRef={portfolioRef}
                    testimonalsRef={testimonalsRef} partnersRef={partnersRef} setIsMenuClicked={setIsMenuClicked}
                    contactUsRef={contactUsRef}
                    setShowWhatService={setShowWhatService}/>


            <Grid container sx={{paddingBottom: {xs: "30px", md: "50px"}}} justifyContent={"center"}>

                <Grid item container justifyContent={"center"} sx={{marginTop: {xs: "20px", md: "50px"}}}>
                    <CustomLabelMediumBold text={"Discuss Your Project with #1 Software Development Company USA "} color={"#5E17EB"}/>
                </Grid>

                <Grid item container xs={10} style={{marginTop: "5px"}} justifyContent={"center"}>
                    <CustomLabelMediumRegular normal={false}
                                              text={"Got an Idea? Let’s Build It Together — Contact Us for Expert Development Solutions. "}
                    />
                </Grid>


                <Grid item container xs={12}  justifyContent={"space-between"}
                      sx={{padding: {xs: "0px 10px", md: "0px 40px"}, marginTop: {xs: "20px", lg: "60px"}}}>


                    <Grid item xs={12} lg={4.8}
                          sx={{maxHeight: "100%", width: "100%", padding: "0px", position: "relative"}}>
                        <Box component={"img"} src={IPHONE151} alt={"OSTRYX"}
                             sx={{height: {lg: "100%"}, width: {xs: "100%", lg: "100%", xlg: "auto"}}}/>
                    </Grid>

                    <ContactUs setShowConfirmation={setShowConfirmation}/>


                </Grid>


                <div ref={contactUsRef} tabIndex={0}></div>

            </Grid>


            {/* <Grid container justifyContent={"space-between"} alignItems={"center"} sx={{padding: {xs: "0px 10px", md: "0px 30px"}, marginTop: {xs: "20px", lg: "0px"}
            ,marginBottom:"40px"}}>

                <Grid item xs={11.4} sm={11.7} md={5.5} lg={5.5}>

                    <Paper sx={{width: "100%", background: "white", borderRadius: "30px", padding: {xs:"10px ",md:"15px"}}}>

                        <Grid container item xs={12} justifyContent={"space-between"}>


                            <Grid item xs={5.8}>
                                <Paper sx={{
                                    background: "#F5F5F5",
                                    borderRadius: "20px",
                                    width: "100%",
                                    padding: "20px 0px"
                                }}>

                                    <Grid container direction={"column"} alignItems={"center"}>

                                        <Grid item>
                                            <LocalPhoneOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "10px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                      text={"Phone"}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "5px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                      text={"+971 50 2452251"}/>
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={5.8}>
                                <Paper sx={{
                                    background: "#F5F5F5",
                                    borderRadius: "20px",
                                    width: "100%",
                                    padding: "20px 0px"
                                }}>

                                    <Grid container direction={"column"} alignItems={"center"}>

                                        <Grid item>
                                            <EmailOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "10px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                      text={"Email"}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "5px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                      text={"info@ostryx.com"}/>
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>


                        <Grid item xs={12} container sx={{marginTop: "20px"}}>
                            <Paper
                                sx={{background: "#F5F5F5", borderRadius: "20px", width: "100%", padding: "30px 0px"}}>

                                <Grid container direction={"column"} alignItems={"center"}>
                                    <Grid item >
                                        <FmdGoodOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                    </Grid>
                                   
                                    <Grid item  sx={{marginTop: "10px"}}>
                                        <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                    text={"Office"}/>
                                    </Grid>

                                    <Grid item sx={{marginTop: "5px"}}>
                                        <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                    text={"MAG 218, Sheikh Mohammed bin Rashid Boulevard, Dubai Marina, UAE"}/>
                                    </Grid>
                                </Grid>

                            </Paper>
                        </Grid>


                    </Paper>

                </Grid>

                <Grid item xs={12} md={5.5} lg={5.8}>
                    <Grid 
                        item 
                        container 
                        justifyContent={{xs:"center",md:"flex-end"}} 
                        sx={{
                            marginTop:{xs:"40px",md:"0px"},
                            height: { xs: "300px", md: "400px" }
                        }} 
                        alignItems={"center"}
                    >
                        <Box
                            component="iframe"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3609.8876117287883!2d55.14895251492798!3d25.087953837748677!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b5a7e0d4629%3A0xad70d7ddd8614c6f!2sMAG%20218%20Tower!5e0!3m2!1sen!2sae!4v1710836040040!5m2!1sen!2sae"
                            sx={{
                                border: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: "20px",
                                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)"
                            }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                const img = document.createElement('img');
                                img.src = StaticMapIcon;
                                img.style.width = '100%';
                                img.style.height = '100%';
                                img.style.borderRadius = '20px';
                                e.target.parentNode.appendChild(img);
                            }}
                        />
                    </Grid>
                </Grid>

            </Grid> */}

            <Grid container justifyContent={"space-between"} alignItems={"center"} sx={{padding: {xs: "0px 10px", md: "0px 30px"}, marginTop: {xs: "20px", lg: "0px"}
            ,marginBottom:"40px"}}>

                <Grid item xs={11.4} sm={11.7} md={5.5} lg={5.5}>

                    <Paper sx={{width: "100%", background: "white", borderRadius: "30px", padding: {xs:"10px ",md:"15px"}}}>

                        <Grid container item xs={12} justifyContent={"space-between"}>


                            <Grid item xs={5.8}>
                                <Paper sx={{
                                    background: "#F5F5F5",
                                    borderRadius: "20px",
                                    width: "100%",
                                    padding: "20px 0px"
                                }}>

                                    <Grid container direction={"column"} alignItems={"center"}>

                                        <Grid item>
                                            <LocalPhoneOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "10px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                      text={"Phone"}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "5px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                      text={"+1 (850) 586-1700"}/>
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid item xs={5.8}>
                                <Paper sx={{
                                    background: "#F5F5F5",
                                    borderRadius: "20px",
                                    width: "100%",
                                    padding: "20px 0px"
                                }}>

                                    <Grid container direction={"column"} alignItems={"center"}>

                                        <Grid item>
                                            <EmailOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "10px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                      text={"Email"}/>
                                        </Grid>

                                        <Grid item sx={{marginTop: "5px"}}>
                                            <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                      text={"info@ostryx.com"}/>
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>


                        <Grid item xs={12} container sx={{marginTop: "20px"}}>
                            <Paper
                                sx={{background: "#F5F5F5", borderRadius: "20px", width: "100%", padding: "30px 0px"}}>

                                <Grid container direction={"column"} alignItems={"center"}>
                                    {/* <Grid container alignItems={"center"} item xs={10} sx={{height: "100%"}}> */}
                                        <Grid item mx={4}>
                                            <FmdGoodOutlinedIcon size={48} sx={{fontSize: "48px"}}/>
                                        </Grid>


                                        {/* <Grid item sx={{height: "100%"}}> */}
                                            {/* <Grid container sx={{height: "100%"}} direction={"column"}
                                                alignItems={"flex-start"} justifyContent={"center"}> */}
                                                <Grid item sx={{marginTop: "10px"}}>
                                                    <CustomLabelXSmallRegular fontWeight={"bold"} color={"#5E17EB"}
                                                                            text={"Office"}/>
                                                </Grid>

                                                <Grid item sx={{marginTop: "5px"}}>
                                                    <CustomLabelXSmallRegular fontWeight={"bold"} color={"#333333"}
                                                                            text={"4628 Southwinds Drive Destin, FL 32550 United States"}/>
                                                </Grid>
                                            {/* </Grid> */}
                                        {/* </Grid> */}

                                    {/* </Grid> */}
                                </Grid>

                            </Paper>
                        </Grid>


                    </Paper>

                </Grid>

                <Grid item xs={12} md={5.5} lg={5.8}>
                    <Grid 
                        item 
                        container 
                        justifyContent={{xs:"center",md:"flex-end"}} 
                        sx={{
                            marginTop:{xs:"40px",md:"0px"},
                            height: { xs: "300px", md: "400px" }
                        }} 
                        alignItems={"center"}
                    >
                        <Box
                            component="iframe"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3442.2868190284776!2d-86.33323449999999!3d30.371212400000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x889159598e0a00d5%3A0x93151a2cd43d26!2s4628%20Southwinds%20Dr%2C%20Destin%2C%20FL%2032550%2C%20USA!5e0!3m2!1sen!2s!4v1743698310716!5m2!1sen!2s"
                            sx={{
                                border: 0,
                                width: "100%",
                                height: "100%",
                                borderRadius: "20px",
                                boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)"
                            }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                const img = document.createElement('img');
                                img.src = StaticMapIcon;
                                img.style.width = '100%';
                                img.style.height = '100%';
                                img.style.borderRadius = '20px';
                                e.target.parentNode.appendChild(img);
                            }}
                        />
                    </Grid>
                </Grid>

            </Grid>


            <Footer/>

        </Grid>
    )
}

export default ContactUsDetails;
